export default [
  {
    path: 'pajak-item',
    redirect: { name: 'itemtaxes' },
    component: { template: '<router-view />' },
    children: [
      {
        path: '/',
        name: 'itemtaxes',
        component: () => import('@pages/itemtaxes/Index.vue'),
        meta: {
          auth:true,
          pageTitle: 'Pajak Item',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Pajak Item',
              active: true
            },
          ],
        }
      },
      {
        path: 'tambah',
        name: 'itemtaxes-add',
        component: () => import('@pages/itemtaxes/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Tambah Pajak Item',
          navActiveLink:'itemtaxes',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Pajak Item',
              to: { name: 'itemtaxes' },
            },
            {
              text: 'Tambah',
              active: true
            },
          ],
        }
      },
      {
        path: ':id',
        name: 'itemtaxes-edit',
        component: () => import('@pages/itemtaxes/Form.vue'),
        meta: {
          auth:true,
          pageTitle: 'Edit Pajak Item',
          navActiveLink:'itemtaxes',
          breadcrumb: [
            {
              text: 'Setting',
            },
            {
              text: 'Pajak Item',
              to: { name: 'itemtaxes' },
            },
            {
              text: 'Edit',
              active: true
            },
          ],
        }
      }
    ]
  }
]